<div *ngIf="successMessage" class="alert alert-success" role="alert">
	<mat-icon>thumb_up</mat-icon> &nbsp;
	<label style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{successMessage}}
	</label>
</div>
<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
	<label style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{errorMessage}}
	</label>
</div>
<div class="row_1">
	<div class="top_grid_agg">
		<div>

		</div>
		<div class="content1">
			<div class="content2">
				<label class="catlabel">Team</label>
				<mat-form-field appearance="outline" class="fixed-select">
					<mat-select [(ngModel)]="teamChosen" name="team" placeholder="Select"
						(selectionChange)="teamChange()">
						<mat-option disabled>
							<ngx-mat-select-search [formControl]="teamFilter" placeholderLabel="Search"
								noEntriesFoundLabel="No Team found" style="flex: 1;">
							</ngx-mat-select-search>
						</mat-option>
						<div style="max-height: 200px; overflow-y: auto;">
							<mat-option *ngFor="let team of filteredTeams | async" [value]="team">
								{{ team.label }}
							</mat-option>
						</div>
					</mat-select>
				</mat-form-field>
				<button class="add_button" (click)="openDialog()" title="Add Team">ADD</button>
				<span style="color:#ff0000" *ngIf="enableData">
					<button class="delete_button" (click)="deleteTeamDialog()" title="Delete Team">DELETE</button>
				</span>
			</div>
			<div class="content2">
				<label class="catlabel" *ngIf="enableData">Manager</label>
				<div *ngIf="enableData">
					<mat-form-field appearance="outline" class="fixed-select">
						<mat-select [(ngModel)]="AMChosen" placeholder="Select" (selectionChange)="updateAM()">
							<mat-option disabled>
								<div
									style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
									<ngx-mat-select-search [formControl]="managerFilter" placeholderLabel="Search"
										noEntriesFoundLabel="No Manager found" style="flex: 1;">
									</ngx-mat-select-search>
								</div>
							</mat-option>
							<div style="max-height: 200px; overflow-y: auto;">
								<mat-option *ngFor="let team of filteredManager | async" [value]="team">
									{{ team.label }}
								</mat-option>
							</div>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
			<div class="content3" *ngIf="enableData">
				<button class="refresh_button" style="margin-left: 0px;" (click)="refreshData()">REFRESH</button>
			</div>
		</div>
		<div *ngIf="enableData" class="content1">
			<div class="content2">
				<label class="catlabel">User</label>
				<mat-form-field appearance="outline" class="fixed-select">
					<mat-select [(ngModel)]="userChosen" placeholder="Select">
						<mat-option disabled>
							<div
								style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
								<ngx-mat-select-search [formControl]="userFilter" placeholderLabel="Search"
									noEntriesFoundLabel="No User found" style="flex: 1;">
								</ngx-mat-select-search>
							</div>
						</mat-option>
						<div style="max-height: 200px; overflow-y: auto;">
							<mat-option *ngFor="let team of filteredUser | async" [value]="team">
								{{ team.label }}
							</mat-option>
						</div>
					</mat-select>
				</mat-form-field>
				<button class="submit_button" (click)="addUser()">ADD USER</button>
			</div>
			<div class="content2">
				<label class="catlabel">Logistics Point</label>
				<mat-form-field appearance="outline" class="fixed-select">
					<mat-select [(ngModel)]="selected_region" placeholder="Select">
						<mat-option disabled>
							<div
								style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
								<ngx-mat-select-search [formControl]="regionFilter" placeholderLabel="Search"
									noEntriesFoundLabel="No Region found" style="flex: 1;">
								</ngx-mat-select-search>
							</div>
						</mat-option>
						<div style="max-height: 200px; overflow-y: auto;">
							<mat-option *ngFor="let team of filteredRegion | async" [value]="team">
								{{ team.label }}
							</mat-option>
						</div>
					</mat-select>
				</mat-form-field>
				<button class="submit_logistics" (click)="addLogistics()">ADD LOGISTICS POINT</button>
			</div>
		</div>
		<div class="grid-agg" *ngIf="enableData">
			<div class="row" [ngStyle]="{'height': dynamicHeightCard + 'px'}">
				<div class="column col-5">
					<!-- style="width: 500px; height: 431px;" -->
					<ag-grid-angular #agGrid id="myGrid" [ngStyle]="{'height': dynamicHeight + 'px',
					'width':'100%' }" class="ag-theme-balham" [columnDefs]="columnDefsUsr" [rowData]="rowDataUsr" [icons]="icons"
						[suppressCellSelection]="true" [paginationPageSize]="paginationPageSize" [theme]="'legacy'"
						(gridReady)="onGridReady($event)" (cellValueChanged)="onDemandsCellValueChanged($event)"
						(window:resize)="sizeToFit()" [context]="context" [icons]="icons"
						[enableCellTextSelection]="true" [ensureDomOrder]="true">
					</ag-grid-angular>
				</div>
				<div class="column col-7">
					<!-- style="width: 779px; height: 431px;" -->
					<ag-grid-angular #agGrid [ngStyle]="{'height': dynamicHeight + 'px',
					'width':'100%' }" id="myGrid" class="ag-theme-balham" [columnDefs]="columnDefsLogistics"
						[rowData]="rowDataLogistics" [icons]="icons" [suppressCellSelection]="true" [theme]="'legacy'"
						(gridReady)="onGridReady($event)" [context]="context" [icons]="icons"
						[enableCellTextSelection]="true" [ensureDomOrder]="true">
					</ag-grid-angular>
				</div>
			</div>
		</div>
	</div>
</div>